/**
 * @prettier
 */
import util from 'util';

export function pretty(object: any): string {
    return util.inspect(object, { depth: null });
}
